import React, { useEffect, useState } from 'react';
import "../../assets/styles/Search.css";
import Popup from "reactjs-popup";
import { motion } from "framer-motion";
import Header from "../../components/Header.js";
import InfoUser from "../../components/Profile/InfoUser.js";
import DataConfirm from "../../components/Profile/DataConfirm.js";
import Collapsible from "react-collapsible";
import Swal from "sweetalert2";
import iconSearch from "../../icons/icon-search.png";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../../components/helper/Loading.js"
import { config } from "../../config.js";
import { apiCheckAccount, apiGetSetting } from "../../services/api.service.js";
import { apiConfirmUpdate, apiUpdateAccount, apiCheckDataAccount, apiFormUpdateAccount } from "../../services/api.service.js";
// import iconArrow from "../../icons/";
import {
  Box,
  Button,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Typography,
  IconButton,
} from "@mui/material";
import { AddPhotoAlternateOutlined, Close } from "@mui/icons-material";
import iconArrow from "../../icons/icon-arrow.png";
import iconSendMail from "../../icons/icon-send-mail.png";
import iconSendPhone from "../../icons/icon-send-phone.png";
import iconImage from "../../icons/icon-image.png";
import iconClose from "../../icons/icon-close.png";
import iconWarning from "../../icons/icon-warning.png";
import iconSuccess from "../../icons/icon-success.png";

function ChangeInfo() {
  const location = useLocation();
  const { userName, data, webSetting, typeModal } = location.state || {};
  const [openResult, setOpenResult] = useState(false);
  const [checkConfirm, setCheckConfirm] = useState(false);
  const [isSendMail, setIsSendMail] = useState(true);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openUploadFile, setOpenUploadFile] = useState(false);
  const [previews, setPreviews] = useState([]);
  const [selectedImage, setSelectedImage] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [infoFileUpload, setInfoFileUpload] = useState("");
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const originalDataUpdate = {
    name: "",
    province: "",
    bank_type_change: "",
    bank_name: "",
    bank_number: "",
    province: "",
    email: "",
    phone_number: "",
  };
  const originalDesChangeBank = {
    title_change_bank: "THAY ĐỔI THÔNG TIN NGÂN HÀNG",
    bank_name: "Tên Ngân Hàng Mới",
    bank_number: "Số Tài Khoản Mới",
  };
  const desBankNew = {
    title_change_bank: "THÊM THÔNG TIN NGÂN HÀNG",
    bank_name: "Tên Ngân Hàng Mới",
    bank_number: "Số Tài Khoản Ngân Hàng Mới",
  };
  const desBankRemove = {
    title_change_bank: "XÓA SỐ TÀI KHOẢN NGÂN HÀNG",
    bank_name: "Tên Ngân Hàng Cần Xóa",
    bank_number: "Số Tài Khoản Cần Xóa",
  };
  const [desChangeBank, setDesChangeBank] = useState(originalDesChangeBank);
  const [dataUpdate, setDataUpdate] = useState(originalDataUpdate);
  const [timesCheckData, setTimesCheckData] = useState(0);
  const [dataCheck, setDataCheck] = useState({
    name: "",
    province: "",
    bank_name: "",
    bank_number: "",
    email: "",
    phone_number: "",
  });
  
  
  const [user, setUser] = useState({
    account: userName,
    update_type: "",
    status: "",
    auto_check: "",
    send_type: "",
  });

  const inputDataCheck = (event) => {
    let { name, value } = event.target;
    setDataCheck({
      ...dataCheck,
      [name]: value,
    });
  };
  
  const inputDataUpdate = (event) => {
    const { name, value } = event.target;
    setDataUpdate({
      ...dataUpdate,
      [name]: value,
    });
    console.log("f9dsfds", name)
    if (name == "bank_type_change") {
      switch (value) {
        case "Thêm số tài khoản": setDesChangeBank(desBankNew)
        break;
        case "Xóa số tài khoản": setDesChangeBank(desBankRemove)
        break;
        case "Đổi số tài khoản": setDesChangeBank(originalDesChangeBank)
        break;
        default: setDesChangeBank(originalDesChangeBank)
      }
    }
  };
  let contentUpdate;

  useEffect(() => {
    updateUserField("update_type", typeModal)
  }, []);

  const validateForm = () => {
    let errors = {};
    let formIsValid = true;

    // Kiểm tra trường Name
    if (!dataCheck.name) {
      formIsValid = false;
      errors.name = 'Vui lòng nhập Họ và Tên';
    }

    // Kiểm tra trường phone_number
    if (data.phone_number) {
      if (!dataCheck.phone_number) {
        formIsValid = false;
        errors.phone_number = 'Vui lòng nhập Số Điện Thoại';
      } else if (!/^\d{10}$/.test(dataCheck.phone_number)) {
        formIsValid = false;
        errors.phone_number = 'Số Điện Thoại không hợp lệ';
      }
    }

    // Kiểm tra trường email
    if (data.email) {
      if (!dataCheck.email) {
        formIsValid = false;
        errors.email = 'Vui lòng nhập Email';
      } else if (!/\S+@\S+\.\S+/.test(dataCheck.email)) {
        formIsValid = false;
        errors.email = 'Email không hợp lệ';
      }
    }

    // Kiểm tra trường bank_name
    if (!dataCheck.bank_name) {
      formIsValid = false;
      errors.bank_name = 'Vui lòng nhập Ngân Hàng';
    }

    // Kiểm tra trường bank_number
    if (!dataCheck.bank_number) {
      formIsValid = false;
      errors.bank_number = 'Vui lòng nhập Số Tài Khoản';
    }
    switch (typeModal) {
      case "full_name": // Kiểm tra trường Name update
      if (!dataUpdate.name) {
        formIsValid = false;
        errors.nameUpdate = 'Vui lòng nhập Họ và Tên mới';
      } else {
        contentUpdate = dataUpdate.name;
      }
      break;
      case "phone_number":// Kiểm tra trường phone_number
        if (!dataUpdate.phone_number) {
          formIsValid = false;
          errors.phoneNumberUpdate = 'Vui lòng nhập Số Điện Thoại mới';
        } else if (!/^\d{10}$/.test(dataUpdate.phone_number)) {
          formIsValid = false;
          errors.phoneNumberUpdate = 'Số Điện Thoại mới không hợp lệ';
        } else {
          contentUpdate = dataUpdate.phone_number;
        }
        break;
      case "email":// Kiểm tra trường email
        if (!dataUpdate.email) {
          formIsValid = false;
          errors.emailUpdate = 'Vui lòng nhập Email mới';
        } else if (!/\S+@\S+\.\S+/.test(dataUpdate.email)) {
          formIsValid = false;
          errors.emailUpdate = 'Email mới không hợp lệ';
        } else {
          contentUpdate = dataUpdate.email;
        }
        break;
      case "bank":// Kiểm tra value bank
        if (!dataUpdate.bank_type_change) {
          formIsValid = false;
          errors.bankTypeChange = 'Vui lòng chọn yêu cầu thay đổi';
        }
        if (!dataUpdate.bank_name) {
          formIsValid = false;
          errors.bankNameUpdate = 'Vui lòng nhập Ngân Hàng mới';
        }
        if (!dataUpdate.bank_number) {
          formIsValid = false;
          errors.bankNumberUpdate = 'Vui lòng nhập Số Tài Khoản mới';
        } else {
          contentUpdate = (dataUpdate.bank_type_change + " - " + dataUpdate.bank_number + " - " + dataUpdate.bank_name)
        }
        if (!dataUpdate.province) {
          formIsValid = false;
          errors.province = 'Vui lòng nhập chi nhánh Ngân Hàng mới';
        }
        break;
        case "birthday": // Kiểm tra trường birth day
          if (!dataUpdate.birth_day) {
            formIsValid = false;
            errors.birthDayUpdate = 'Vui lòng chọn ngày tháng năm sinh';
          } else {
            contentUpdate = dataUpdate.birth_day;
          }
          break;
      default: break
    }
    console.log(errors)
    setErrors(errors);
    return formIsValid;
  };
  const modalConfirmUpdate = (type) => {
    if (validateForm()){
      if (type === 'files') {
          user.send_type = 'files';
          updateUserField('send_type', 'files')
          updateUser('files')
      } else {
        Swal.fire({
          icon: "warning",
          title: (type === "mail") ? `Bạn có thể sử dụng email ${data.email} để gửi mail xác thực thông tin?` : `Bạn có thể sử dụng số điện thoại ${data.phone_number} để gửi tin nhắn xác thực thông tin?`,
          text: (type === "mail") ? `Gửi SMS` : `Gửi email`,
          html: `
            <div className="confirm-update-wrapper">
            ${data.phone_number && type === "mail"
              ? '<button id="change_send_type" class="button-confirm-update">Xác nhận qua SMS</button>' 
              : data.email && type === "phone_number" ? '<button id="change_send_type" class="button-confirm-update">Xác nhận qua email</button>' : ''}
              <button id="confirm_send_type" class="button-confirm-update">Đúng, tiếp tục</button>
              </div>
              `,
          showCancelButton: false,
          showConfirmButton: false,
          didRender: () => {
            document.getElementById('change_send_type')?.addEventListener('click', () => {
              Swal.close();
              modalConfirmUpdate(type === "mail" ? "phone_number" : "mail");
            });
            document.getElementById('confirm_send_type').addEventListener('click', () => {
              Swal.close();
              updateUser(type)
            });
          }
        })
      }
    }
  }
  
  const updateUserField = (field, value) => {
    setUser((prevUser) => ({
      ...prevUser,
      [field]: value,
    }));
  };
  
  const openModalConfirm = (type) => {
    setOpenConfirm(true);
  };
  const confirmUpdateUser = async (body, type) => {
    setLoading(true)
    let updateInfo = await apiFormUpdateAccount(body, selectedFiles);
    setLoading(false)
    if (updateInfo) {
      openModalConfirm(type);
    }
  };
  const updateUser = async (type) => {
    if (validateForm()) {
      if (type === "mail") {
        user.send_type = 'email';
        setIsSendMail(true);
      } else if (type === "phone_number") {
        user.send_type = 'phone_number';
        setIsSendMail(false);
      } else if (type === "files") {
        user.send_type = 'files';
        updateUserField('send_type', 'files')
        setIsSendMail(false);
      }
      let body = {
        ...user,
        data_check: {
          ...dataCheck,
        },
        data_update: {
          update_type: user.update_type,
          content: contentUpdate,
        }
      };
      if (body?.data_check?.name) {
        body.data_check.name = body?.data_check?.name?.trim();
      }
      setLoading(true)
      let checkDataOld = await apiCheckDataAccount(body);
      setLoading(false)
      if (checkDataOld) {
        if (type === "files" && selectedImage.length === 0) {
          let descriptionFileUpload = "Bạn vui lòng tải lên ít nhất 2 trong " + webSetting?.des_up_files?.length+ " hình ảnh dưới để xác minh tài khoản<br/><br/>";
          if (webSetting?.des_up_files?.length > 0) {
            webSetting.des_up_files.forEach(element => {
              descriptionFileUpload +=  (element) ? "" + element + "</br>" : ""
            });
          }
          descriptionFileUpload = "<p>" + descriptionFileUpload + "</p>";
          setInfoFileUpload(descriptionFileUpload)
          setOpenUploadFile(true);
          return;
        }
        let confirmUpdate = checkDataOld.result;
        let value_auto_check = confirmUpdate ? "check_success" : "check_fail";
        updateUserField("auto_check", value_auto_check);
        body.auto_check = value_auto_check;
        //nếu thông tin đúng hết hoặc đã nhập lại từ 5 lần và có số điện thoại hoặc email đúng thì tự động confirm gửi yêu cầu
        if (confirmUpdate || (timesCheckData >= 100 && checkDataOld.allowSubmit >0)) {
          confirmUpdateUser(body, type);
        } else {
          setLoading(false)
          Swal.fire({
            icon: (checkDataOld.countMatch/checkDataOld.count <0.5) ? "error" : "warning",
            title: "Chú ý",
            text: (checkDataOld.allowSubmit == 0 && type != 'files') ? "Sai số điện thoại và email liên kết" : "Thông tin cũ bạn nhập đúng " + Math.round(checkDataOld.countMatch/checkDataOld.count*100) + "%",
            showCancelButton: true,
            cancelButtonText: 'Quay về chỉnh sửa',
            confirmButtonText: 'Tiếp tục gửi',
            // chỉ khi có ít nhất 1 thông tin (số điện thoại hoặc email) đúng hoặc phương thức xác thực hình ảnh thì mới hiển thị nút confirm gửi yêu cầu
            showConfirmButton: (type === 'files' || checkDataOld.allowSubmit > 0),
            reverseButtons: true
          }).then((result) => {
            if (result.isConfirmed) {
              confirmUpdateUser(body, type);
            } else if (result.isDismissed) {
              setTimesCheckData(timesCheckData + 1)
            }
          });
        }
      }
    }
  };
  const closeModalConfirm = () => {
    setOpenConfirm(false);
    navigate("/profile", { state: {userName, data, webSetting} });
  };

  const handleImageUpload = async (event) => {
    const files = Array.from(event.target.files);
    const validFiles = files.filter((file) => {
      if (file.size > 3 * 1024 * 1024) {
        Swal.fire({
          icon: "error",
          title: "Thất bại!",
          text: `Ảnh ${file.name} vượt quá giới hạn 3MB.`,
        });
        return false;
      }
      return true;
    });
    
    setSelectedFiles((prevFiles) => [...prevFiles, ...validFiles]);
    const newPreviews = validFiles.map((file) => URL.createObjectURL(file));
    if (previews.length + newPreviews.length > 7) {
      Swal.fire({
        icon: "error",
        title: "Thất bại!",
        text: "Hệ thống yêu cầu tối đa 7 ảnh",
      });
      return;
    }
    const base64Images = await Promise.all(
      validFiles.map((file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
        });
      })
    );
    setPreviews((prevPreviews) => [...prevPreviews, ...newPreviews]);
    setSelectedImage((prevImages) => [...prevImages, ...base64Images]);
  };

  const handleRemoveImage = (index) => {
    setPreviews((prevPreviews) => prevPreviews.filter((_, i) => i !== index));
    setSelectedImage((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  return (
    <div className="container">
    {(loading) && (
      <Loading loading={loading}/>
    )}
      <motion.div
        className="app"
        initial={{ x: "100vw", opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: "-100vw", opacity: 0 }}
        transition={{ type: "spring", stiffness: 1000, damping: 200, duration: 10 }}
      >
        <Header isPageSearch={false} pageToAcction={"/profile"} data={ {userName, data, webSetting} }/>

        <div className="content">
          {/* <Popup open={open} onClose={() => {setOpen(false); document.body.style.overflow = 'auto';}} position={"center"} closeOnDocumentClick={false} nested> */}
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} id="modal-info" className="modal-info">
              <div className="info-current">
                <Collapsible open={false} trigger={["GỢI Ý THÔNG TIN ĐÃ LIÊN KẾT", <img src={iconArrow} key="icon-arrow" alt="icon-arrow" />]}>
                  <InfoUser />
                </Collapsible>
              </div>
              <div className="confirm-info-old">
                <span className="modal-titlte">VUI LÒNG NHẬP LẠI THÔNG TIN ĐÃ LIÊN KẾT</span>
                <div className="input-info">
                  <input type="text" name="name" value={dataCheck.name} onChange={inputDataCheck} placeholder="Họ Và Tên" />
                  {errors.name && <p className="error">{errors.name}</p>}
                  <input type="text" name="phone_number" value={dataCheck.phone_number} onChange={inputDataCheck} placeholder="Số Điện Thoại" />
                  {errors.phone_number && <p className="error">{errors.phone_number}</p>}
                  <input type="text" name="email" value={dataCheck.email} onChange={inputDataCheck} placeholder="Email" />
                  {errors.email && <p className="error">{errors.email}</p>}
                  <select
                    name="bank_name"
                    value={dataCheck.bank_name}
                    onChange={inputDataCheck}
                  >
                    <option value="">Ngân Hàng</option>
                    {config.LIST_BANK_NAME.map((bank, index) => (
                      <option key={index} value={bank}>
                        {bank == "Military Bank, MBB" ? "MB bank" : bank}
                      </option>
                    ))}
                  </select>         
                  {errors.bank_name && <p className="error">{errors.bank_name}</p>}
                  <input type="text" name="bank_number" value={dataCheck.bank_number} onChange={inputDataCheck} placeholder="Số Tài Khoản" />
                  {errors.bank_number && <p className="error">{errors.bank_number}</p>}
                </div>
              </div>
              <div className="confirm-info-new">
                {/* <span className="modal-titlte">THAY ĐỔI THÔNG TIN MỚI</span> */}
                {
                  {
                    "full_name": 
                    <>
                      <span className="modal-titlte">THAY ĐỔI HỌ TÊN MỚI</span>
                      <div className="input-info">
                        <input type="text" name="name" onChange={inputDataUpdate} placeholder="Họ Tên Mới" />
                        {errors.nameUpdate && <p className="error">{errors.nameUpdate}</p>}
                      </div>
                    </>,
                    "phone_number": 
                    <>
                      <span className="modal-titlte">THAY ĐỔI SỐ ĐIỆN THOẠI MỚI</span>
                      <div className="input-info">
                        <input type="text" name="phone_number" onChange={inputDataUpdate}  placeholder="Số Điện Thoại Mới" />
                        {errors.phoneNumberUpdate && <p className="error">{errors.phoneNumberUpdate}</p>}
                      </div>
                    </>,
                    "email": 
                    <>
                      <span className="modal-titlte">THAY ĐỔI EMAIL MỚI</span>
                      <div className="input-info">
                        <input type="text" name="email" onChange={inputDataUpdate} placeholder="Email Mới" />
                        {errors.emailUpdate && <p className="error">{errors.emailUpdate}</p>}
                      </div>
                    </>,
                    "bank": 
                    <>
                    <span className="modal-titlte">{desChangeBank.title_change_bank}</span>
                    <div className="input-info">
                      <select type="input" name="bank_type_change" onChange={inputDataUpdate}>
                        <option value="">Chọn yêu cầu thay đổi</option>
                        {config.LIST_REQUEST_BANK.map((bank, index) => (
                          <option key={index} value={bank}>
                            {bank}
                          </option>
                        ))}
                      </select>
                      <select
                        name="bank_name"
                        value={dataUpdate.bank_name}
                        onChange={inputDataUpdate}
                      >
                        <option value="">Ngân Hàng Mới</option>
                        {config.LIST_BANK_NAME.map((bank, index) => (
                          <option key={index} value={bank}>
                            {bank == "Military Bank, MBB" ? "MB bank" : bank}
                          </option>
                        ))}
                      </select> 
                      {errors.bankNameUpdate && <p className="error">{errors.bankNameUpdate}</p>}
                      <input type="text" name="bank_number" onChange={inputDataUpdate} placeholder={desChangeBank.bank_number} />
                      {errors.bankNumberUpdate && <p className="error">{errors.bankNumberUpdate}</p>}
                      <input type="text" name="province" onChange={inputDataUpdate} placeholder="Chi Nhánh Ngân Hàng Mới" />
                      {errors.province && <p className="error">{errors.province}</p>}
                    </div>
                    </>,
                    "birthday":
                    <>
                      <span className="modal-titlte">THAY ĐỔI NGÀY SINH</span>
                      <div className="input-info">
                        <input type="date" name="birth_day" onChange={inputDataUpdate} placeholder="ngày tháng năm sinh" defaultValue="2000-12-01"/>
                        {errors.birthDayUpdate && <p className="error">{errors.birthDayUpdate}</p>}
                      </div>
                    </>,
                  }[typeModal]
                }
              </div>
              <div className="mode-verify">
                <span className="modal-titlte">VUI LÒNG LỰA CHỌN HÌNH THỨC GỬI XÁC THỰC</span>
                <div className="action action-verify">
                    <button id="confirm_files_btn" onClick={() => updateUser("files")}>
                      &nbsp;
                      <img src={iconImage} alt="icon-bank" />
                      <div className="button-text">
                        <div className="text-top">Tải hình ảnh hoặc video để xác thực</div>
                        <div className="text-bottom">JPG, JPEG, PNG dung lượng nhỏ hơn 1MB</div>
                      </div>
                    </button>
                </div>
                {(typeModal !== "birthday") &&
                <>
                  <div className="action action-verify">
                    { data.email &&
                    <button onClick={() => updateUser("mail")} className="action-verify-btn">
                      <img src={iconSendMail} alt="icon-bank" />
                      &nbsp; GỬI QUA EMAIL
                    </button>
                    }
                    { data.phone_number &&
                    <button onClick={() => updateUser("phone_number")} className="action-verify-btn">
                      <img src={iconSendPhone} alt="icon-bank" />
                      &nbsp; GỬI QUA SĐT
                    </button>
                    }
                  </div>
                  <p className='note-verify-image'>
                    {/* Nếu quý khách không có email hoặc SDT để gửi thông tin, vui lòng nhấn nút dưới đây để thực hiện thay thế */}
                  </p>
                </>
                }
              </div>
            </motion.div>
          {/* </Popup> */}
          <Popup open={openConfirm} closeOnDocumentClick={false} onClose={closeModalConfirm} position={"center"} nested>
            <motion.div
              initial={{ opacity: 0, y: 75 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              id="modal-confirm"
              className="modal-confirm"
            >
              <div className="modal-close">
                <a className="icon-close" onClick={closeModalConfirm}>
                  <img src={iconClose} alt="icon-close" />
                </a>
              </div>
                {user.send_type === 'files' ? (
                  <div className="modal-confirm-content">
                    <img style={{ marginBottom: "20px" }} src={iconSuccess} alt="icon-success" />
                    <span>Yêu cầu của quý khách của quý khách đã được ghi nhận. Vui lòng đợi xét duyệt.</span>
                    <div className="btn-wrapper-home">
                      <div className="btn-send btn-home">
                          <a href={ webSetting.link_home }
                              target="_blank"
                              rel="noopener noreferrer">VỀ TRANG CHỦ
                          </a>
                      </div>
                    </div>
                    <div className="notification">
                      <p style={{ color: "#F7B922", padding: "3px 0px",margin: "0px"}}>Lưu ý:</p>
                      <p>- Quý khách vui lòng kiểm tra kết quả xử lý của hệ thống tại Hòm Thư.</p>
                      <p>- Liên hệ <a href={ webSetting.link_cskh }
                        target="_blank"
                        rel="noopener noreferrer">CSKH</a> nếu cần hỗ trợ thêm.</p>
                  </div>
                  </div>
                ): (
              <div className="modal-confirm-content">
                <img className="icon-warning" src={iconWarning} />
                {isSendMail ? (
                  <p>
                    Vui lòng sử dụng email đã liên kết <span style={{ color: "green" }}>{data.email}</span>, gửi tin nhắn tới email {" "}
                    <span style={{ color: "red" }}>{ webSetting.email || "gmail.com" }</span>, với nội dung:
                  </p>
                ) : user.send_type === 'phone_number' ? (
                  <p>
                    Vui lòng sử dụng số điện thoại đã liên kết<span style={{ color: "green" }}>{data.phone_number == 'not_check' ? '' : ' ' + data.phone_number}</span>, gửi tin nhắn tới số điện thoại {" "}
                    <span style={{ color: "red" }}>{ webSetting.phone_number || "" }</span>, với nội dung:
                  </p>
                ) : (
                  <p>
                    Yêu cầu của quý khách của quý khách đã đ. Vui lòng đợi xét duyệt.
                  </p>
                )}
                <DataConfirm user={user}
                dataCheck = {dataCheck}
                dataUpdate = {dataUpdate}
                webSetting = {webSetting}/>
                <div className="notification">
                  <p style={{ color: "#F7B922", padding: "3px 0px",margin: "0px"}}>Lưu ý:</p>
                  <p>- Sau khi nhận được { (isSendMail) ? 'email' : 'tin nhắn' }, hệ thống xét duyệt từ 2-5 phút.</p>
                  <p>- Quý khách vui lòng kiểm tra kết quả xử lý của hệ thống tại Hòm Thư.</p>
                  <p>- Liên hệ <a href={ webSetting.link_cskh }
                    target="_blank"
                    rel="noopener noreferrer">CSKH</a> nếu cần hỗ trợ thêm.</p>
              </div>
              </div>
              )}
            </motion.div>
          </Popup>
          <Popup open={openResult} onClose={() => setOpenResult(false)} position={"center"}>
            <motion.div initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="modal-success">
              <div className="modal-close">
                <a className="icon-close" onClick={() => setOpenResult(false)}>
                  <img src={iconClose} alt="icon-close" />
                </a>
              </div>
              {checkConfirm ? (
                <div className="modal-result-content">
                  <img style={{ marginBottom: "20px" }} src={iconSuccess} alt="icon-success" />
                  <span>Chúng tôi đã nhận được yêu cầu của Quý khách, vui lòng chờ 2-5 phút và nhận kết quả phản hồi tại Hòm thư nội bộ</span>
                </div>
                ) : (
                <div className="modal-result-content">
                  <img style={{ marginBottom: "20px" }} src={iconWarning} alt="icon-success" />
                  <span>Yêu cầu của bạn chưa được ghi nhận, vui lòng thử lại hoặc liên hệ chăm sóc khách hàng</span>
                </div>
              )}
            </motion.div>
          </Popup>
          <Popup open={openUploadFile} onClose={() => setOpenUploadFile(false)} position={"center"}>
            <motion.div initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="modal-success">
              <div className="modal-close">
                <a className="icon-close" onClick={() => setOpenUploadFile(false)}>
                  <img src={iconClose} alt="icon-close" />
                </a>
              </div>
                <div className="modal-result-content">
                  <img style={{ marginBottom: "20px" }} src={iconWarning} alt="icon-success"/>
                  <span>Bạn cần cung cấp thêm hình ảnh để xác minh thông tin.</span>
                  
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{
                      color: "black",
                      marginBottom: "-10px",
                      marginTop: "-15px",
                      fontWeight: "bold",
                    }}
                  >
                    <div className='upload-file' dangerouslySetInnerHTML={{ __html: infoFileUpload }}/>
                  </Typography>
                  <Box
                    display="flex"
                    alignItems="center"
                    marginY={1}
                    flexWrap="wrap"
                    gap="8px 8px"
                  >
                    {previews.map((preview, index) => (
                      <Box
                        onClick={() => handleRemoveImage(index)}
                        key={index}
                        sx={{
                          maxHeight: 80,
                          maxWidth: 90,
                          width: "auto",
                          height: "auto",
                          position: "relative",
                          overflow: "hidden",
                          cursor: "pointer",
                          "&:hover .delete-button": {
                            display: "block",
                          },
                        }}
                      >
                        <img
                          src={preview}
                          alt={`preview-${index}`}
                          style={{
                            width: "auto",
                            maxWidth: "100%",
                            height: "auto",
                            maxHeight: "100%",
                            borderRadius: 4,
                            objectFit: "cover",
                          }}
                        />
                        <IconButton
                          className="delete-button"
                          sx={{
                            position: "absolute",
                            top: 0,
                            right: 0,
                            color: "red",
                            p: 0,
                          }}
                        >
                          <Close fontSize="small" />
                        </IconButton>
                      </Box>
                    ))}
                    
                    <Box>
                    <input
                      accept="image/*"
                      style={{ display: "none" }}
                      id="upload-button"
                      type="file"
                      onChange={handleImageUpload}
                      multiple
                    />
                    <label htmlFor="upload-button">
                      <Button
                        variant="text"
                        component="span"
                        sx={{
                          width: "90px",
                          height: "80px",
                          color: "#6BB0C8",
                          borderColor: "#6BB0C8",
                          borderStyle: "solid",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          "&:hover": {
                            borderColor: "#6BB0C8",
                            color: "#6BB0C8",
                            transform: "scale(1.05)", // thêm zoom nhẹ
                          },
                          transition: "all 0.3s ease",
                        }}
                      >
                        {/* SVG Icon ở đây */}
                        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 71 70" fill="none">
                          <path d="M15.1375 1.3252C27.8543 0.60654 40.5997 0.561587 53.3201 1.19043L55.863 1.3252H55.864C59.114 1.50811 62.1944 2.80657 64.5896 4.99121L65.0593 5.44043C67.361 7.74221 68.7922 10.7632 69.1228 13.9883L69.1746 14.6357C69.8932 27.3528 69.9381 40.0988 69.3093 52.8193L69.1746 55.3623V55.3633C68.9916 58.6134 67.6923 61.6936 65.5076 64.0889L65.0593 64.5586C62.7577 66.8603 59.7365 68.2915 56.5115 68.6221L55.864 68.6738H55.863C43.1465 69.3942 30.4015 69.4389 17.6814 68.8086L15.1375 68.6738C11.8872 68.491 8.80643 67.1917 6.41089 65.0068L5.94116 64.5586C3.63936 62.2568 2.20761 59.2358 1.87671 56.0107L1.82593 55.3633V55.3623C1.1073 42.6455 1.06234 29.9001 1.69116 17.1797L1.82593 14.6357C2.00902 11.3856 3.3081 8.30551 5.49292 5.91016L5.94116 5.44043C8.24317 3.13853 11.2646 1.7066 14.49 1.37598L15.1375 1.3252Z" fill="url(#paint0_linear)" stroke="#13AFF1" strokeWidth="1.5"/>
                          <path d="M17.2089 18.8681V12.3867H21.5298V18.8681H28.0112V23.189H21.5298V29.6703H17.2089V23.189H10.7275V18.8681H17.2089ZM23.6903 31.8308V25.3494H30.1716V18.8681H45.2948L49.2484 23.189H56.097C58.4735 23.189 60.4179 25.1334 60.4179 27.5099V53.4353C60.4179 55.8118 58.4735 57.7562 56.097 57.7562H21.5298C19.1533 57.7562 17.2089 55.8118 17.2089 53.4353V31.8308H23.6903ZM38.8134 51.2749C44.7763 51.2749 49.6157 46.4354 49.6157 40.4726C49.6157 34.5097 44.7763 29.6703 38.8134 29.6703C32.8506 29.6703 28.0112 34.5097 28.0112 40.4726C28.0112 46.4354 32.8506 51.2749 38.8134 51.2749ZM31.9 40.4726C31.9 44.2966 34.9894 47.386 38.8134 47.386C42.6374 47.386 45.7269 44.2966 45.7269 40.4726C45.7269 36.6486 42.6374 33.5591 38.8134 33.5591C34.9894 33.5591 31.9 36.6486 31.9 40.4726Z" fill="url(#paint1_linear)"/>
                          <defs>
                            <linearGradient id="paint0_linear" x1="35.4999" y1="-0.270795" x2="35.4999" y2="68.7699" gradientUnits="userSpaceOnUse">
                              <stop stopColor="#E8F5FF"/>
                              <stop offset="1" stopColor="#B4DFFF"/>
                            </linearGradient>
                            <linearGradient id="paint1_linear" x1="35.5727" y1="12.3867" x2="35.5727" y2="57.7562" gradientUnits="userSpaceOnUse">
                              <stop stopColor="#466AFF"/>
                              <stop offset="1" stopColor="#06B8FF"/>
                            </linearGradient>
                          </defs>
                        </svg>
                      </Button>
                    </label>
                  </Box>
                  </Box>
                  <Typography variant="caption">
                    Cung cấp hình ảnh đúng theo mô tả để được xét duyệt
                  </Typography>
                  {selectedImage.length >= 2 ? (
                    <div>
                      <button id="complete_files_btn" onClick={() => {setOpenUploadFile(false); updateUser(user.send_type)}}>
                        XÁC NHẬN
                      </button>
                    </div>
                  ) : 
                    <div>
                    <button id="complete_files_btn_disable">
                    </button>
                  </div>
                  }
                </div>
            </motion.div>
          </Popup>
        </div>
      </motion.div>
    </div>
  );
}

export default ChangeInfo;
